type FormatCurrencyOptions = {
  maximumFractionDigits?: number;
  minimumFractionDigits?: number;
};

export function formatCurrency(
  amount: number,
  { maximumFractionDigits = 0, minimumFractionDigits = 0 }: FormatCurrencyOptions = {},
) {
  return amount.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits,
    maximumFractionDigits,
  });
}

/**
 * Whole dollars when the amount is whole, otherwise always two decimals:
 * 500 -> "$500", 0.01 -> "$0.01", 4.5 -> "$4.50". Matches the banking offer card.
 */
export function formatCurrencyWithCentsIfNeeded(amount: number) {
  const fractionDigits = amount % 1 !== 0 ? 2 : 0;
  return formatCurrency(amount, {
    maximumFractionDigits: fractionDigits,
    minimumFractionDigits: fractionDigits,
  });
}
